import { render, staticRenderFns } from "./NavigationBarHelpMenu.vue?vue&type=template&id=106c11ef&scoped=true&"
import script from "./NavigationBarHelpMenu.vue?vue&type=script&lang=js&"
export * from "./NavigationBarHelpMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106c11ef",
  null
  
)

export default component.exports